import { render, staticRenderFns } from "./talent_acquisition.vue?vue&type=template&id=64dab852&scoped=true"
import script from "./talent_acquisition.vue?vue&type=script&lang=js"
export * from "./talent_acquisition.vue?vue&type=script&lang=js"
import style0 from "./talent_acquisition.vue?vue&type=style&index=0&id=64dab852&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dab852",
  null
  
)

export default component.exports